import {GetParams, PaginationData} from '@app/shared';
import {HttpParams} from '@angular/common/http';

// Transforma los GetParams en HttpParams
export function convertGetParamsToHttpParams(getParams: GetParams): HttpParams {
  let params = new HttpParams()
    .set('startRow', getParams.startRow.toString())
    .set('endRow', getParams.endRow.toString())
    .set('sortDirection', getParams.sortDirection)
    .set('sortProperty', getParams.sortProperty);

  if (getParams.filterProperty) {
    params = params.set('filterProperty', getParams.filterProperty);
  }
  if (getParams.filterValue) {
    params = params.set('filterValue', getParams.filterValue);
  }
  if (getParams.entityId) {
    params = params.set('entityId', getParams.entityId);
  }
  if (getParams.entityType) {
    params = params.set('entityType', getParams.entityType);
  }
  if (getParams.companyId) {
    params = params.set('companyId', getParams.companyId);
  }

  return params;
}

export function getPagination(total: number, pageSize: number = 10, currentPage: number = 1): PaginationData {
  // Validaciones básicas
  if (total < 0) throw new Error("El total no puede ser negativo");
  if (pageSize <= 0) throw new Error("El tamaño de página debe ser mayor a 0");

  // Ajustar página inválida
  const validCurrentPage = Math.max(1, Math.floor(currentPage));

  // Calcular valores base
  const totalPages = Math.ceil(total / pageSize);
  const clampedPage = Math.min(validCurrentPage, totalPages);

  // Calcular filas
  let startRow = (clampedPage - 1) * pageSize;
  let endRow = clampedPage * pageSize;

  // Ajustar para el último elemento de la página
  if (endRow > total) endRow = total;

  // Caso especial cuando no hay datos
  if (total === 0) {
    startRow = 0;
    endRow = 0;
  }

  return {
    startRow,
    endRow,
    totalPages: Math.max(1, totalPages), // Mínimo 1 página
    currentPage: clampedPage,
    pageSize,
    totalItems: total,
  };
}

export function setGetParamsById(id: number): GetParams {
  return {
    startRow: 0,
    endRow: 1,
    sortDirection: 'asc',
    sortProperty: 'id',
    filterProperty: 'id',
    filterValue: id.toString(),
  }
}
